import React from 'react';
import { render } from 'react-dom';
import { createStore } from 'redux';
import todoApp from './Reducers';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';

import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';
import '@blueprintjs/table/lib/css/table.css';
import 'simplebar/dist/simplebar.min.css';
import './index.css';
import './responsive.css';

/* eslint-disable no-underscore-dangle */
const Store = createStore(
  todoApp /* preloadedState, */,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */

render(<App Store={Store} />, document.getElementById('root'));

// Unregister service worker to prevent stale caching issues
serviceWorker.unregister();
